import { Component, OnInit } from '@angular/core';
import { UsersService, IUser, IRegion2 } from '../users.service';
import { ActivatedRoute } from '@angular/router';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { RolesService, IRole, IDepartment, ICompany } from '../../roles/roles.service';
import { Subscription } from 'rxjs';
import * as $ from 'jquery';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { HttpErrorResponse } from '@angular/common/http';


@Component({
  selector: 'app-edit-user',
  templateUrl: './edit-user.component.html',
  styleUrls: ['./edit-user.component.scss']
})
export class EditUserComponent implements OnInit {

  constructor(private service: UsersService, private route: ActivatedRoute, private rolesService: RolesService,
    private snackBar: MatSnackBar, public dialog: MatDialog) {
    this.subscription = this.service.getSelectedFolder().subscribe(res => {
      this.selectedFolderId = res;
    });
    this.subscription = this.service.getSelectedReport().subscribe(res => {
      this.selectedReportId = res;
    });

  }

  user: IUser;
  regions: IRegion2[] = [];
  loading = false;
  allRoles: IRole[] = [];
  $userRegions: IRegion2[] = [];
  emailPattern = '^[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,4}$';
  userForm = new UntypedFormGroup({});
  selectedFolderId: number;
  selectedReportId: number;
  subscription: Subscription;
  companies: ICompany[] = [];
  departments: IDepartment[] = [];

  hidePassword = true;
  hideConfirmPassword = true;

  formGroupisEmpty = true;

  ngOnInit() {
    const userId = this.route.snapshot.params.id;
    const $user = this.service.getSavedUsers(userId);
    this.regions = this.service.getRegions();
    this.getRoles();

    $user.subscribe((res: IUser) => {
      this.user = res;
      // console.log(this.user);
      if (this.user !== undefined) {
        this.getUserRegions(userId);
      }
    });
    this.service.setSelectedUserId(userId);
  }

  checkObject(obj) {
    return $.isEmptyObject(obj);
  }

  getUserRegions(userId: string) {
    this.loading = true;
    this.service.getUserRegions(userId).subscribe(res => {
      if (res) {
        this.$userRegions = res;
        this.userForm = this.createFormGroup();

        this.getDepartments();
        this.formGroupisEmpty = this.checkObject(this.userForm.controls);
        this.userForm.setValidators([this.checkPasswords]);
        this.userForm.updateValueAndValidity({ emitEvent: false });
        this.loading = false;
      }
    });
  }

  createFormGroup() {
    const group: any = {};

    // tslint:disable-next-line:forin
    for (const k in this.user) {
      group[k] = new UntypedFormControl(this.user[k]);
    }
    group['mioID'] = new UntypedFormControl(this.$userRegions);

    if (!group['Password']) {
      group['Password'] = new UntypedFormControl();
      group['ConfirmPassword'] = new UntypedFormControl();

    }
    group['Password'].setValidators([this.checkPass]);
    group['phoneNumber'].setValidators([this.checkPhone]);

    let phoneNumber = group['phoneNumber'].value;
    if (phoneNumber && phoneNumber.length === 12) {
      phoneNumber = phoneNumber.slice(2, 12);
    }
    group['phoneNumber'].setValue(phoneNumber);

    return new UntypedFormGroup(group);
  }

  checkPhone(control: UntypedFormControl) {
    const patt = '^[0-9]{10}$';
    if (control.value && control.value.length > 0) {
      const res = control.value.match(patt);
      if (res === null) {
        return { err: true };
      }
    }
    return null;
  }

  checkPass(control: UntypedFormControl) {
    const value = control.value;
    if (value !== null && value !== undefined && String(value).length > 0) {
      // минимум 6 символов и хотя бы одна цифра
      const pas = /^(?=.*\d).{6,}$/;
      const ok = pas.test(String(value));
      if (!ok) {
        return { passPatt: true };
      }
    }
    return null;
  }

  checkPasswords(group: UntypedFormGroup) {
    const passControl = group.get('Password');
    const confirmControl = group.get('ConfirmPassword');
    const pass = passControl ? passControl.value : null;
    const confirmPass = confirmControl ? confirmControl.value : null;

    // If user is not changing password, keep form valid.
    if (!pass && !confirmPass) {
      if (confirmControl && confirmControl.errors && confirmControl.errors.notSame) {
        const nextErrors = { ...confirmControl.errors };
        delete nextErrors.notSame;
        confirmControl.setErrors(Object.keys(nextErrors).length ? nextErrors : null);
      }
      return null;
    }

    const mismatch = pass !== confirmPass;

    // Put the error on ConfirmPassword too, so mat-error can bind to that control.
    if (confirmControl) {
      const currentErrors = confirmControl.errors || null;
      const hasNotSame = !!(currentErrors && currentErrors.notSame);

      if (mismatch && !hasNotSame) {
        confirmControl.setErrors({ ...(currentErrors || {}), notSame: true });
      }

      if (!mismatch && hasNotSame) {
        const nextErrors = { ...(currentErrors || {}) };
        delete nextErrors.notSame;
        confirmControl.setErrors(Object.keys(nextErrors).length ? nextErrors : null);
      }
    }

    return mismatch ? { notSame: true } : null;
  }


  compareObjects2(o1: any, o2: IRegion2) {
    return o1 === o2.id;
  }

  private extractServerErrorMessages(err: any): string[] {
    const body = err instanceof HttpErrorResponse ? err.error : (err?.error ?? err);
    if (!body) {
      return [];
    }

    if (typeof body === 'string') {
      return [body].map(x => x.trim()).filter(Boolean);
    }

    const messages: string[] = [];

    if (body.error_description && typeof body.error_description === 'string') {
      messages.push(body.error_description);
    }

    if (body.modelState && typeof body.modelState === 'object') {
      // tslint:disable-next-line:forin
      for (const key in body.modelState) {
        const value = body.modelState[key];
        const normalizedKey = (key || '').trim();

        if (Array.isArray(value)) {
          value.filter(Boolean).forEach((item: any) => {
            const text = String(item).trim();
            if (!text) {
              return;
            }
            messages.push(normalizedKey ? `${normalizedKey}: ${text}` : text);
          });
        } else if (value) {
          const text = String(value).trim();
          if (text) {
            messages.push(normalizedKey ? `${normalizedKey}: ${text}` : text);
          }
        }
      }
    }

    // ASP.NET Core default validation shape: { title, errors: { field: [msg] } }
    if (body.errors && typeof body.errors === 'object') {
      // tslint:disable-next-line:forin
      for (const key in body.errors) {
        const value = body.errors[key];
        const normalizedKey = (key || '').trim();
        if (Array.isArray(value)) {
          value.filter(Boolean).forEach((item: any) => {
            const text = String(item).trim();
            if (!text) {
              return;
            }
            messages.push(normalizedKey ? `${normalizedKey}: ${text}` : text);
          });
        } else if (value) {
          const text = String(value).trim();
          if (text) {
            messages.push(normalizedKey ? `${normalizedKey}: ${text}` : text);
          }
        }
      }
    }

    if (body.message && typeof body.message === 'string') {
      messages.push(body.message);
    }

    const unique: string[] = [];
    messages
      .map((x: string) => x.trim())
      .filter(Boolean)
      .forEach((m: string) => {
        if (unique.indexOf(m) === -1) {
          unique.push(m);
        }
      });

    return unique;
  }

  private showServerError(err: any, fallback: string) {
    const messages = this.extractServerErrorMessages(err);
    const message = messages.length ? messages.join(' | ') : fallback;

    // Interceptor can show a generic error first; replace it with a detailed one.
    this.snackBar.dismiss();
    this.snackBar.open(message, '', {
      duration: 8000,
      verticalPosition: 'top',
      horizontalPosition: 'right',
      panelClass: ['snackbar-error']
    });
  }

  onSubmit() {
    if (this.userForm.valid) {
      if (this.userForm.controls.companyID.value === 0 || this.userForm.controls.departmentID.value === 0) {
        this.userForm.controls.companyID.setValue(null);
        this.userForm.controls.departmentID.setValue(null);
      }
      this.service.editUser(this.userForm.value).subscribe(_ => {
        if (typeof this.userForm.value.mioID[0] === 'number') {
          this.service.setUserRegions(this.userForm.value.mioID.join(), this.userForm.value.id).subscribe({
            next: () => {
              {
                this.snackBar.open('Пользователь успешно обновлен!', '', {
                  duration: 5000,
                  verticalPosition: 'top',
                  horizontalPosition: 'right',
                  panelClass: ['snackbar-succes']
                });
              }
            },
            error: (err) => {
              this.showServerError(err, 'Ошибка при обновлении регионов пользователя!');
            }
          });
        } else {
          const ids = [];
          for (let i = 0; i < this.userForm.value.mioID.length; i++) {
            ids.push(this.userForm.value.mioID[i].id);
          }
          this.service.setUserRegions(ids.join(), this.userForm.value.id).subscribe({
            next: () => {
              this.snackBar.open('Пользователь успешно обновлен!', '', {
                duration: 5000,
                verticalPosition: 'top',
                horizontalPosition: 'right',
                panelClass: ['snackbar-succes']
              });
            },
            error: (err) => {
              this.showServerError(err, 'Ошибка при обновлении регионов пользователя!');
            }
          });
        }
      });
    }
  }

  getRoles() {
    this.rolesService.getList().subscribe(roles => {
      this.allRoles = roles;
    });
  }

  getDepartments() {
    this.rolesService.getDepartments().subscribe(res => {
      this.companies = res;
      const selectedCompany = this.companies.find(x => x.id === this.userForm.controls.companyID.value);
      if (selectedCompany) {
        this.departments = selectedCompany.departments;
      }
    });
  }


  onFoldersTabClick(link: boolean) {
    if (link) {
      this.selectedFolderId = undefined;
      this.selectedReportId = undefined;
    }
  }

  onReportsTabClick(link: boolean) {
    if (link) {
      this.selectedReportId = undefined;
    }
  }

  setSelectedCompany(departments: IDepartment[]) {
    this.departments = departments;
  }

  // tslint:disable-next-line:use-life-cycle-interface
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

}







